export const changeRadius = 'changeRadius';
export const changeActiveWheels = 'changeActiveWheels';
export const setRadius = 'setRadius';
export const setIsActive = 'setIsActive';
export const changeWheelDiskType = 'changeWheelDiskType';
export const setWheelDiskType = 'setWheelDiskType';
export const changeIsRunflat = 'changeIsRunflat';
export const setIsRunflat = 'setIsRunflat';
export const changeCutType = 'changeCutType';
export const setCutType = 'setCutType';
